import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_2 = { class: "dialog-footer" }
const _hoisted_3 = { style: {"display":"flex","align-items":"center","column-gap":"10px","justify-content":"space-between"} }
const _hoisted_4 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_PageHeader = _resolveComponent("PageHeader")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_button_group = _resolveComponent("el-button-group")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_PageHeader, null, {
      default: _withCtx(() => [
        _cache[9] || (_cache[9] = _createElementVNode("h2", null, "Utenti iscritti", -1)),
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_el_button, {
            type: "success",
            onClick: _cache[0] || (_cache[0] = ($event: any) => {_ctx.showDialog = true;})
          }, {
            default: _withCtx(() => [
              _createVNode(_component_font_awesome_icon, {
                icon: "building-circle-arrow-right",
                style: {"margin-right":"8px"}
              }),
              _cache[7] || (_cache[7] = _createElementVNode("b", null, "Invita utente", -1))
            ]),
            _: 1
          }),
          (_ctx.store.admin.role === 'SUPER')
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 0,
                type: "danger",
                onClick: _ctx.resetTerms
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_font_awesome_icon, {
                    icon: "ban",
                    style: {"margin-right":"8px"}
                  }),
                  _cache[8] || (_cache[8] = _createElementVNode("b", null, "Azzera termini di servizio", -1))
                ]),
                _: 1
              }, 8, ["onClick"]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }),
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      data: _ctx.items.items,
      stripe: "",
      border: "",
      style: {"width":"100%"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, { label: "Codice fiscale" }, {
          default: _withCtx((scope) => [
            _createElementVNode("b", null, _toDisplayString(scope.row.fiscalCode), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "phoneNumber",
          label: "Numero di telefono"
        }),
        _createVNode(_component_el_table_column, { label: "Attivo" }, {
          default: _withCtx((scope) => [
            _createVNode(_component_el_switch, {
              modelValue: scope.row.isActive,
              "onUpdate:modelValue": ($event: any) => ((scope.row.isActive) = $event),
              disabled: ""
            }, null, 8, ["modelValue", "onUpdate:modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, { label: "Termini e condizioni" }, {
          default: _withCtx((scope) => [
            _createVNode(_component_el_switch, {
              modelValue: scope.row.termsAndConditions,
              "onUpdate:modelValue": ($event: any) => ((scope.row.termsAndConditions) = $event),
              disabled: ""
            }, null, 8, ["modelValue", "onUpdate:modelValue"])
          ]),
          _: 1
        }),
        (_ctx.store.admin.role === 'SUPER')
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 0,
              label: "Strutture associate",
              width: "170",
              align: "center"
            }, {
              default: _withCtx((scope) => [
                _createVNode(_component_el_tag, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(scope.row.organizations.length), 1)
                  ]),
                  _: 2
                }, 1024),
                _createVNode(_component_el_button, {
                  style: {"margin-left":"8px"},
                  size: "small",
                  onClick: ($event: any) => (_ctx.showOrganizationsDetails(scope.row))
                }, {
                  default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                    _createTextVNode(" Dettagli ", -1)
                  ]))]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_el_table_column, { label: "Data iscrizione" }, {
          default: _withCtx((scope) => [
            _createTextVNode(_toDisplayString(_ctx.getDateString(scope.row.createdAt)), 1)
          ]),
          _: 1
        }),
        (_ctx.store.admin.role === 'SUPER')
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 1,
              label: "Operazioni",
              width: "140",
              align: "center"
            }, {
              default: _withCtx((scope) => [
                _createVNode(_component_el_button_group, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      type: "danger",
                      onClick: ($event: any) => (_ctx.deleteUser(scope.row))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_font_awesome_icon, { icon: "trash" })
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["data"])), [
      [_directive_loading, _ctx.isBusy]
    ]),
    _createVNode(_component_el_pagination, {
      style: {"margin-top":"10px"},
      background: "",
      layout: "prev, pager, next",
      "page-count": _ctx.items.pages,
      "current-page": _ctx.currentPage,
      "onUpdate:currentPage": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.currentPage) = $event)),
      onChange: _ctx.onCurrentPageChanged
    }, null, 8, ["page-count", "current-page", "onChange"]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.showDialog,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.showDialog) = $event)),
      title: "Invita utente",
      width: "800"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_el_button, {
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showDialog = false))
          }, {
            default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
              _createTextVNode("Annulla", -1)
            ]))]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "success",
            loading: _ctx.isDialogBusy,
            onClick: _ctx.associateOrganization
          }, {
            default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
              _createTextVNode(" Invita ", -1)
            ]))]),
            _: 1
          }, 8, ["loading", "onClick"])
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, { "label-position": "top" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { label: "Codice fiscale" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  class: "uppercase",
                  modelValue: _ctx.fiscalCode,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.fiscalCode) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            (_ctx.store.admin.role === 'SUPER')
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 0,
                  label: "Seleziona una struttura"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_radio_group, {
                      modelValue: _ctx.selectedOrganization,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selectedOrganization) = $event))
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.organizations, (organization) => {
                          return (_openBlock(), _createBlock(_component_el_radio, {
                            key: organization.id,
                            value: organization.organizationId,
                            border: ""
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(organization.name), 1)
                            ]),
                            _: 2
                          }, 1032, ["value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    (_ctx.selectedUser !== null && _ctx.showOrganizationsDialog)
      ? (_openBlock(), _createBlock(_component_el_dialog, {
          key: 0,
          modelValue: _ctx.showOrganizationsDialog,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.showOrganizationsDialog) = $event)),
          width: "500",
          title: "Strutture associate"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table, {
              data: _ctx.selectedUser.organizations,
              stripe: "",
              border: "",
              style: {"width":"100%"},
              "max-height": "500"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, { label: "Nome" }, {
                  default: _withCtx((scope) => [
                    _createElementVNode("div", _hoisted_3, [
                      _createElementVNode("b", null, _toDisplayString(scope.row.name), 1),
                      (scope.row.logo !== null)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            src: 'data:image/png;base64,' + scope.row.logo,
                            alt: "",
                            style: {"max-height":"30px"}
                          }, null, 8, _hoisted_4))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["data"])
          ]),
          _: 1
        }, 8, ["modelValue"]))
      : _createCommentVNode("", true)
  ]))
}